export const getAvatarName = (avatar) =>
  avatar.includes('-') ? avatar.replace('avatar-', '').replace('@2x.png', '') : avatar;
